var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cepingwancheng"},[_c('div',[_vm._v("恭喜测评完成")])])
}]

export { render, staticRenderFns }